<script setup lang="ts">
import { inject } from "vue"

interface Props {
  iconName: string | "stop-icon.svg" | "trash-icon.svg"
}
defineProps<Props>()

const BUCKET_URL = inject("RAIDSTORM_BUCKET_URL")
</script>

<template>
  <img :src="BUCKET_URL + iconName" :alt="iconName" />
</template>
